module.exports = __webpack_public_path__ + "static/mailchimp-c7209e130604f8f32dea03cf39a367ea.svg";